<template>
    <FormSection
        title="Admission Information"
        :full-height="false"
        validation-renderer="bootstrap-form-renderer"
        :application-id="patient.application"
    >
        <template #content>
            <div class="row mt-2 px-4">
                <div class="col-12 offset-md-1 col-md-10 row g-0">
                    <div class="form-group col-12 col-md-4 pe-lg-2">
                        <label for="admission-type">
                            Type of Admission
                            <span class="text-danger">*</span>
                        </label>
                        <select
                            name="admission-type"
                            class="form-select"
                            v-model="patient.admissionType"
                            @blur="v$.patient.admissionType.$touch"
                            :class="`${!v$.patient.admissionType.$error ? '' : 'field-invalid'}`"
                        >
                            <option :value="0">Select Type of Admission</option>
                            <option v-for="[key, value] of enumToMap(AdmissionTypes)" :value="value.value">
                                {{ value.name }}
                            </option>
                        </select>
                        <span v-if="v$.patient.admissionType.$error" class="field-invalid"
                            >{{v$.patient.admissionType.$errors[0].$message}}</span
                        >
                    </div>
                    <div class="form-group col-12 col-md-4 pe-lg-2">
                        <label for="admission-type">
                            Admission Source
                            <span class="text-danger">*</span>
                        </label>
                        <select
                            name="admission-type"
                            class="form-select"
                            v-model="patient.admissionSource"
                            @blur="v$.patient.admissionSource.$touch"
                            :class="`${!v$.patient.admissionSource.$error ? '' : 'field-invalid'}`"
                        >
                            <option :value="0">Select Admission Source</option>
                            <option v-for="[key, value] of enumToMap(AdmissionSources)" :value="value.value">
                                {{ value.name }}
                            </option>
                        </select>
                        <span v-if="v$.patient.admissionSource.$error" class="field-invalid"
                            >{{v$.patient.admissionSource.$errors[0].$message}}</span
                        >
                    </div>
                    <div class="col-12 d-flex flex-wrap mt-2">
                        <div class="form-check custom-radio form-check-inline">
                            <input
                                type="radio"
                                id="patient-new-admission"
                                name="admission-source"
                                class="form-check-input au-target"
                                :checked="!patient.isTransfer"
                                @change="handleAdmissionSourceTypeSelection()"
                                :disabled="isReadOnly"
                            />
                            <label class="form-check-label" for="patient-new-admission">
                                <span class="me-1">New Admission</span>
                            </label>
                        </div>
                        <div class="col-12 mt-3 row g-0">
                            <template v-if="!patient.isTransfer">
                                <div class="form-group col-12 col-lg-4 pe-lg-2">
                                    <label for="benefit-period-number">
                                        Benefit Period Number <span class="text-danger ms-1">*</span>
                                    </label>
                                    <input
                                        :readonly="isReadOnly"
                                        class="form-control"
                                        type="text"
                                        name="benefit-period-number"
                                        placeholder="Enter Benefit Period Number"
                                        v-model="patient.benefitPeriodNumber"
                                        v-number-only
                                        @blur="v$.patient.benefitPeriodNumber.$touch"
                                        :class="`${!v$.patient.benefitPeriodNumber.$error ? '' : 'field-invalid'}`"
                                    />
                                    <span v-if="v$.patient.benefitPeriodNumber.$error" class="field-invalid">{{
                                        v$.patient.benefitPeriodNumber.$errors[0].$message
                                    }}</span>
                                </div>
                                <div class="form-group col-12 col-lg-4 pe-lg-2">
                                    <label for="benefit-period-number"> Routine Home Care Low Rate Start Date </label>
                                    <p>Pending Admission Date</p>
                                </div>
                                <div
                                    class="form-group col-12 col-lg-12"
                                    v-if="Number(patient.benefitPeriodNumber) >= 2"
                                >
                                    <label for="previous-hospice-admission">
                                        Previous Hospice Admission Within Last 60 days

                                        <i
                                            class="fas fa-info-circle text-primary font-size-xs"
                                            v-tooltip="{
                                                title: 'Select this option if the patient was discharged from hospice and then readmitted within 60 days of their previous discharge using the Medicare hospice benefit.'
                                            }"
                                        ></i>
                                    </label>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input
                                            type="radio"
                                            id="hospiceAdmissionNo"
                                            name="hospiceAdmission"
                                            class="custom-control-input me-2"
                                            v-model="patient.previousHospiceAdmission"
                                            :value="false"
                                            @change="handlePreviousAdmissionChange(false)"
                                        />
                                        <label class="custom-control-label" for="hospiceAdmissionNo"> No </label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline mt-1">
                                        <input
                                            type="radio"
                                            id="hospiceAdmissionYes"
                                            name="hospiceAdmission"
                                            class="custom-control-input me-2"
                                            v-model="patient.previousHospiceAdmission"
                                            :value="true"
                                            @change="handlePreviousAdmissionChange(true)"
                                        />
                                        <label class="custom-control-label" for="hospiceAdmissionYes"> Yes </label>
                                    </div>
                                    <div
                                        class="form-group col-12 col-lg-4 pe-lg-4"
                                        v-if="
                                            Number(patient.benefitPeriodNumber) >= 2 &&
                                            patient.previousHospiceAdmission === true
                                        "
                                    >
                                        <label for="benefit-period-number">
                                            Previous Enrollment Days
                                            <i
                                                class="fas fa-info-circle text-primary font-size-xs"
                                                v-tooltip="{
                                                    title: 'Enter the number of days the patient received hospice services under the Medicare hospice benefit during their previous admission. This value is used to determine the transition from the routine home care high rate to the routine home care low rate.'
                                                }"
                                            ></i>
                                        </label>
                                        <input
                                            class="form-control"
                                            type="text"
                                            name="previous-enrollment-days"
                                            placeholder="Previous Enrollment Days"
                                            v-model="patient.previousEnrollmentDays"
                                        />
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="form-check custom-radio form-check-inline pb-3">
                        <input
                            type="radio"
                            id="patient-hospice-to-hospice"
                            name="admission-source"
                            class="form-check-input"
                            :checked="patient.isTransfer"
                            @change="handleAdmissionSourceTypeSelection()"
                            :disabled="isReadOnly"
                        />
                        <label class="form-check-label" for="patient-hospice-to-hospice">
                            <span class="me-1">Hospice to Hospice Transfer</span>
                        </label>
                    </div>
                    <template v-if="patient.isTransfer">
                        <HospiceTransferForm
                            :patient="patient"
                            :benefitPeriodStartDate="benefitPeriodStartDate"
                            :handleDateChange="handleBenfitPeriodStartDate"
                            :benefitPeriodEndDate="benefitPeriodEndDate"
                            :homePhoneNumberOptions="homePhoneNumberOptions"
                            :isReadOnly="isReadOnly"
                        />
                    </template>
                    <a
                        class="fw-bold"
                        @click="$router.push('/patients/benefit-period-manager/${patient.id}')"
                        v-if="showBenefitPeriodManager && hasViewBenefitPeriodPermission"
                    >
                        Benefit Period Manager
                    </a>
                </div>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./AdmissionInformation.ts"></script>
